export default {
    "Welcome to React": "Welcome to React and react-i18next",
    description: {
        part1: "Edit <1>src/App.js</1> and save to reload.",
        part2: "Learn React",
    },
};
